
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressCalculatorsMtgFR]",
      function () {
        return require("private-next-pages/[...wordpressCalculatorsMtgFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressCalculatorsMtgFR]"])
      });
    }
  